import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ResourceColumn, ResourceListPage } from '../../components/resource/ResourceListPage';
import { Checklist } from '../../types/logistica';
import { checklistsService } from '../../services';

const columns: ResourceColumn<Checklist>[] = [
  { header: "Veículo", accessor: "veiculo_display" },
  { header: "Template", accessor: "template_display" },
  { header: "Responsável", accessor: "responsavel_display" },
  { header: "Status", accessor: "status" },
  { header: "Data Execução", accessor: "data_execucao" },
];

export const ChecklistsListPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <ResourceListPage
      title="Checklists"
      description="Registro de checklists realizados em veículos."
      columns={columns}
      service={checklistsService}
      createPath="/admin/logistica/checklists/novo"
      onEdit={(item) => item.id && navigate(`/admin/logistica/checklists/${item.id}`)}
    />
  );
};
